import { FetcherAmplify } from './FetcherAmplify';
import { FetcherAxios } from './FetcherAxios';

const fetcherAmplify = new FetcherAmplify();
const fetcherAxios = new FetcherAxios();

export { fetcherAmplify, fetcherAxios };
